/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccountAttachSenderRoutePlanMutation($vendorAccountId: ID!, $routePlanId: [ID!]!) {
  VendorAccountAttachSenderRoutePlan(routePlanId: $routePlanId, vendorAccountId: $vendorAccountId) {
    message
    status
  }
}
`
